import type { RefObject } from 'react';

import type { Chat } from '@mint-sdk/api-ai-assistant';

import { AiChart } from '../../../../components/index.js';
import { formatLabel } from '../../../../helpers/charts.js';
import type { ConstructorGraphProps, ContentBlock } from '../../types.js';
import { RelatedBlockWrapper } from '../related/RelatedBlockWrapper.jsx';

const ChartBlock = ({
  date,
  isAgentic,
  dataframe,
  graph,
  block,
  relatedBlocks,
  blockRefs,
  containerRef,
  chartComponent,
}: {
  date: string;
  isAgentic?: boolean;
  dataframe: Chat.DataframeType;
  graph: Chat.Graph;
  block: ContentBlock;
  relatedBlocks: ContentBlock[];
  blockRefs: RefObject<Map<string, HTMLDivElement>>;
  containerRef?: RefObject<HTMLDivElement | null>;
  chartComponent?: React.ComponentType<ConstructorGraphProps>;
}) => {
  const shouldDisplayCharts =
    graph && Object.keys(graph).length && graph.instructions;

  if (!shouldDisplayCharts) return null;

  const chartName = formatLabel(block.varName);
  const ChartComponent = chartComponent ?? AiChart;

  return (
    <RelatedBlockWrapper
      blockId={block.id}
      blockRefs={blockRefs}
      containerRef={containerRef}
      relatedBlocks={relatedBlocks}
    >
      <ChartComponent
        date={date}
        isAgentic={isAgentic}
        dataframe={dataframe}
        graph={graph}
        chartName={chartName}
      />
    </RelatedBlockWrapper>
  );
};

export { ChartBlock };
